import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter", "count", "warning"]
  static values = { field: String, max: Number, html: Boolean }

  connect() {
    this.field = document.getElementById(this.fieldValue)
    const accessible = this.htmlValue
      ? [document.getElementById(`${this.fieldValue}_editor`), document.getElementById(`${this.fieldValue}_source`)]
      : [this.field]
    accessible.filter(Boolean).forEach(input => {
      const ids = new Set((input.getAttribute("aria-describedby") || "").split(/\s+/).filter(Boolean))
      ids.add(this.counterTarget.id)
      input.setAttribute("aria-describedby", [...ids].join(" "))
    })
    this.update()
  }

  update() {
    if (!this.field) return
    let text = this.field.value || ""
    if (this.htmlValue) {
      const fragment = new DOMParser().parseFromString(text, "text/html")
      fragment.querySelectorAll("script, style, iframe").forEach(node => node.remove())
      fragment.querySelectorAll("br").forEach(node => node.replaceWith(" "))
      fragment.querySelectorAll("div, p, li, blockquote, pre, h1, h2, h3, h4, h5, h6").forEach(node => node.append(" "))
      text = fragment.body.textContent.replace(/[\s\u200b\ufeff]+/g, " ").trim()
    }
    const length = Array.from(text).length
    const excess = Math.max(0, length - this.maxValue)
    this.countTarget.textContent = `${length} / ${this.maxValue} знаков`
    this.warningTarget.hidden = excess === 0
    this.warningTarget.textContent = excess ? `Превышение на ${excess}. Рекомендуется сократить текст.` : ""
    this.counterTarget.classList.toggle("text-danger", excess > 0)
    this.counterTarget.classList.toggle("text-body-secondary", excess === 0)
    this.element.classList.toggle("seo-field-overflow", excess > 0)
  }
}
